import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { Colors } from "../../constants/colors";
import AllStyles from "../../theme/styles";

const availableVariants = Object.keys(AllStyles);

const variantsToComponents = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  textLink: "span",
  bold: "span",
  tableList: "span",
};

const RenderIfInvalidVariant = ({ variant }) => {
  if (availableVariants.indexOf(variant) === -1 && variant !== "default") {
    return (
      <span
        style={{
          fontSize: 11,
          color: "white",
          backgroundColor: "red",
          padding: "2px",
        }}
      >
        {variant}
      </span>
    );
  } else {
    return null;
  }
};

const SFTypography = React.forwardRef(
  (
    {
      component = "div",
      variant = "default",
      children,
      className,
      sx = {},
      noWrap = false,
      align = "inherit",
      color = null,
      italic = false,
      hasHtml = false,
      textEllipsis = false,
      selectable = false,
      forceComponent = false
    },
    ref
  ) => {
    //added this to tranform string containing html into actually html
    if (hasHtml && typeof children === "string") {
      return (
        <Typography
          ref={ref}
          noWrap={noWrap}
          align={align}
          className={className}
          variant={variant}
          dangerouslySetInnerHTML={{ __html: children }}
          component={forceComponent ? forceComponent : variantsToComponents[variant] ?? component}
          sx={{
            ...sx,
            ...(color && { color: `${color}.main` }),
            ...(italic && { fontStyle: "italic" }),
            ...(textEllipsis && {
              overflow: "hidden",
              textOverflow: "ellipsis",
            }),
            ...(selectable && { userSelect: "text", cursor: "auto" }),
          }}
        />
      );
    }

    return (
      <Typography
        ref={ref}
        noWrap={noWrap}
        align={align}
        className={className}
        variant={variant}
        component={forceComponent ? forceComponent : variantsToComponents[variant] ?? component}
        sx={{
          ...sx,
          ...(color && { color: `${color}.main` }),
          ...(italic && { fontStyle: "italic" }),
        }}
      >
        {children} <RenderIfInvalidVariant variant={variant} />
      </Typography>
    );
  }
);

SFTypography.propTypes = {
  /* The text content to be displayed  */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  sx: PropTypes.object,
  /* The variant declared in the theme */
  variant: PropTypes.oneOf(availableVariants),
  /*The html element that will be rendered*/
  component: PropTypes.oneOf(["div", "span", "p", "h1", "h2", "h3", "h4"]),
  noWrap: PropTypes.bool,
  align: PropTypes.oneOf(["center", "inherit", "justify", "left", "right"]),
  color: PropTypes.oneOf([
    ...Object.keys(Colors).map((x) => x.toLocaleLowerCase()),
  ]),
  hasHtml: PropTypes.bool,
  italic: PropTypes.bool,
  //This property determines if the text should be selectable or not
  selectable: PropTypes.bool,
};

export default SFTypography;
